/**
 * wangjunfa
 * 规范
 * name 大驼峰
 */
const company = [
  {
    path: '/company',
    name: 'CompanyList',
    component: () => import(/* webpackChunkName: "company" */ '@/views/company/list')
  }
];
export default company;
